/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseLocationResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ResponseLocationResource'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ReverseGeocodingResult = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseLocationResource);
  }
}(this, function(ApiClient, ResponseLocationResource) {
  'use strict';




  /**
   * The ReverseGeocodingResult model module.
   * @module model/ReverseGeocodingResult
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ReverseGeocodingResult</code>.
   * @alias module:model/ReverseGeocodingResult
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>ReverseGeocodingResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReverseGeocodingResult} obj Optional instance to populate.
   * @return {module:model/ReverseGeocodingResult} The populated <code>ReverseGeocodingResult</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('bestMatchLocation')) {
        obj['bestMatchLocation'] = ResponseLocationResource.constructFromObject(data['bestMatchLocation']);
      }
      if (data.hasOwnProperty('nearbyLocations')) {
        obj['nearbyLocations'] = ApiClient.convertToType(data['nearbyLocations'], [ResponseLocationResource]);
      }
    }
    return obj;
  }

  /**
   * @member {module:model/ResponseLocationResource} bestMatchLocation
   */
  exports.prototype['bestMatchLocation'] = undefined;
  /**
   * @member {Array.<module:model/ResponseLocationResource>} nearbyLocations
   */
  exports.prototype['nearbyLocations'] = undefined;



  return exports;
}));



